import axios from 'axios';

export async function init({ commit, dispatch }) {
	await dispatch('get');
	commit('INIT');
}

export async function save({ commit }, datasource) {
	const { data } = await axios.post('/datasource', {
		type: datasource.type,
		customerNumber: `${datasource.customerNumber}`,
	});
	commit('RESET');
	commit('UPDATE_DATASOURCE', data);
}

export async function get({ commit }) {
	try {
		commit('RESET');
		const { data } = await axios.get('/datasource');
		commit('UPDATE_DATASOURCE', data);
	} catch (error) {
		if (!error.handled) {
			if (error.response.status !== 404) {
				throw error;
			}

			commit('UPDATE_DATASOURCE', {
				type: 'no_datasource',
			});
		}
	}
}
